module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"","ctaOne":"","copyToClipboard":""},"es-MX":{"title":"Mesa de regalos","ctaOne":"Lista de regalos","copyToClipboard":"Copiar"}}')
  delete Component.options._Ctor
}
